module.exports = require('./squad');
